import React, { useState } from "react";
import styles from "./SharedAccess.module.css";
import { Dropdown, InputField, Modal } from "../../../../components";
import { LuUserRoundPlus } from "react-icons/lu";
import { PiSealCheck } from "react-icons/pi";
import { IoWarningOutline } from "react-icons/io5";
import { CusModulesMiddleware } from "../../../../Store/Middlewares/CusModulesMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
const SharedAccess = ({ accessSharingModal, setAccessSharingModal }) => {
  const [accessSuccessModal, setAccessSuccessModal] = useState(false);
  const [accessDeniedModal, setAccessDeniedModal] = useState(false);
  const [accessEmail, setAccessEmail] = useState("");
  const dispatch = useDispatch();
  const MODULE_DETAILS = useSelector(
    (state) => state?.CusModulesReducer?.modulesDetail
  );
  const shareAccess = () => {
    if (!accessEmail) {
      dispatch(showAlert({ type: "Error", message: "Please enter email" }));
    } else {
      dispatch(
        CusModulesMiddleware.shareAccess({
          email: accessEmail,
          asset_id: MODULE_DETAILS?.asset_id,
          module_id: MODULE_DETAILS?.id,
        })
      )
        .then(() => {
          setAccessSharingModal(false);
          setAccessSuccessModal(true);
          setAccessEmail('')
        })
        .catch(() => {
          setAccessDeniedModal(true);
        });
    }
  };
  return (
    <div className={styles.mainCont}>
      <Modal
        open={accessSharingModal}
        onCancel={() => setAccessSharingModal(false)}
        imageClass={styles.access_modalImg}
        icon={
          <LuUserRoundPlus
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Temporary Access Sharing"}
        width={"400px"}
        twoButton
        okBtnTitle={"Share"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => setAccessSharingModal(false)}
        onClickOkButton={shareAccess}
      >
        {/* <div className={styles.access_modalBox}> */}
        <InputField
          className={styles.access_modalInput}
          label={"Email"}
          value={accessEmail}
          onChange={(e) => setAccessEmail(e.target.value)}
          placeholder={"chris@email.com"}
        />
        {/* </div>   */}
      </Modal>

      {/* /////////////////////////Access Successfull///////////////////////// */}

      <Modal
        open={accessSuccessModal}
        onCancel={() => setAccessSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Access Shared successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAccessSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      {/* /////////////////////////Unable to access///////////////////////// */}

      <Modal
        open={accessDeniedModal}
        onCancel={() => setAccessDeniedModal(false)}
        icon={
          <IoWarningOutline
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Unable to  Share Access!"}
        text={" Email not found: k.r.mastrangelo@outlook.com"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setAccessDeniedModal(false)}
        // headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default SharedAccess;
